import { render, staticRenderFns } from "./MemberScreen.vue?vue&type=template&id=2be908e1&"
import script from "./MemberScreen.vue?vue&type=script&lang=js&"
export * from "./MemberScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports